import CircularProgress from '@material-ui/core/CircularProgress';
import { Switch } from '@orientaction/commons';
import { CompassUserContext } from '@orientaction/Context';
import { useAlert, useCompassMenu } from '@orientaction/hooks';
import { NEEDS_TEST_SERVICE_IDS, shouldHideCompass, userHasAnyService } from '@orientaction/utils';
import { ChangeEvent, FC, useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Animation from '../../../GlobalRestitution/CompassCard/Animation';
import locale from '../locale.json';
import { useCompassHeroStyles } from './CompassHero.styles';

const CompassHero: FC = () => {
  const classes = useCompassHeroStyles();
  const history = useHistory();
  const { userInfos, adminView } = useContext<any>(CompassUserContext);
  const { updateRotate, rotate } = useCompassMenu();
  const [isActive, setIsActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const alert = useAlert();

  const { year: paramYear }: any = useParams();
  const currentYear = new Date().getFullYear();
  const disableCompass = currentYear !== +paramYear;
  const hideCompass = shouldHideCompass(userInfos);

  useEffect(() => {
    if (hideCompass && !adminView) {
      history.push('/main');
    }
  }, [history, hideCompass, adminView]);

  if (hideCompass && !adminView) {
    return null;
  }

  const isNonRattachedBeneficiary = !userInfos?.rattachement;
  const canAccessNeeds =
    userHasAnyService(userInfos, NEEDS_TEST_SERVICE_IDS) || isNonRattachedBeneficiary;

  const updateMyRotate = async () => {
    setLoading(true);
    try {
      await updateRotate(rotate.id, rotate.deg);
    } catch {
      alert.openSimpleAlert();
    } finally {
      setLoading(false);
    }
  };

  const handleChangeSwitch = (e: ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    if (!checked) {
      updateMyRotate();
    }
    setIsActive(checked);
  };

  return (
    <div className={classes.heroCard}>
      <div className={classes.heroVisual}>
        <Animation canAccessNeeds={canAccessNeeds} isActive={isActive} />
      </div>

      <div className={classes.heroContent}>
        <h2 className={classes.heroHeading}>{locale.compassTitle}</h2>
        <p className={classes.heroDescription}>{locale.compassDescription}</p>

        {!adminView && (
          <div className={classes.switchRow}>
            {loading ? (
              <CircularProgress size={20} />
            ) : (
              <>
                <Switch
                  checked={isActive}
                  disabled={disableCompass}
                  onChange={handleChangeSwitch}
                />
                <span className={classes.switchLabel}>{locale.moveNeedle}</span>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CompassHero;
